module.exports = __webpack_public_path__ + "img/title-1.9e7bd920.png";